module.exports = __webpack_public_path__ + "img/椭圆 1@3x.67a8b01a.png";